import React, { createContext, useContext, useCallback } from 'react';

interface RocketContextType {
  rocket: () => void;
}

const RocketContext = createContext<RocketContextType | null>(null);

export const RocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const rocket = useCallback(() => {
    const logo = document.querySelector('.navbar-brand-box svg') as SVGElement;
    
    if (logo) {
      // Remove any existing animation
      logo.classList.remove('logo-animated');
      
      // Force reflow to restart animation
      void (logo as any).offsetWidth;
      
      // Add the animation class
      logo.classList.add('logo-animated');
      
      // Remove the class after animation completes
      setTimeout(() => {
        logo.classList.remove('logo-animated');
      }, 1000); // 1s animation duration
    }
  }, []);

  return (
    <RocketContext.Provider value={{ rocket }}>
      {children}
    </RocketContext.Provider>
  );
};

export const useRocketContext = () => {
  const context = useContext(RocketContext);
  if (!context) {
    throw new Error('useRocketContext must be used within a RocketProvider');
  }
  return context;
};